import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import avatar from 'flarum/common/helpers/avatar';
import username from 'flarum/common/helpers/username';
export default class MundialUserDetailsModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "entry", null);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "vote", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.entry = this.attrs.entry;
    this.loadDetails();
  }
  className() {
    return 'MundialUserDetailsModal Modal--medium';
  }
  title() {
    const usernameStr = this.entry.user() ? this.entry.user().displayName() : app.translator.trans('nagusi-match-ratings.forum.mundial.default_user_label');
    return app.translator.trans('nagusi-match-ratings.forum.mundial.user_prediction_title', {
      username: usernameStr
    });
  }
  loadDetails() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-vote',
      params: {
        user_id: this.entry.userId()
      }
    }).then(voteResp => {
      if (voteResp && voteResp.data) {
        this.vote = voteResp.data;
      }
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  content() {
    if (this.loading) {
      return m("div", {
        style: "text-align: center; padding: 40px;"
      }, m(LoadingIndicator, null));
    }
    const user = this.entry.user();
    if (!this.vote) {
      return m("div", {
        style: "text-align: center; padding: 25px;"
      }, m("p", null, app.translator.trans('nagusi-match-ratings.forum.mundial.prediction_not_found')));
    }

    // Get the associated team objects from the store or payload
    const findTeam = teamId => {
      return app.store.getById('nagusi_mundial_teams', String(teamId));
    };
    const team1 = findTeam(this.vote.attributes.teamPot1Id);
    const team2 = findTeam(this.vote.attributes.teamPot2Id);
    const team3 = findTeam(this.vote.attributes.teamPot3Id);
    const team4 = findTeam(this.vote.attributes.teamPot4Id);
    const details = [{
      pot: 1,
      team: team1,
      count: this.vote.attributes.teamPot1Count || 0
    }, {
      pot: 2,
      team: team2,
      count: this.vote.attributes.teamPot2Count || 0
    }, {
      pot: 3,
      team: team3,
      count: this.vote.attributes.teamPot3Count || 0
    }, {
      pot: 4,
      team: team4,
      count: this.vote.attributes.teamPot4Count || 0
    }];
    return m("div", {
      className: "GorbeaUserDetails",
      style: "padding: 20px;"
    }, m("div", {
      className: "GorbeaUserDetails-profile",
      style: "display: flex; align-items: center; gap: 15px; margin-bottom: 25px; border-bottom: 1px solid #f0f0f0; padding-bottom: 20px;"
    }, user && avatar(user, {
      className: 'Player-Avatar-Medium'
    }), m("div", {
      className: "GorbeaUserDetails-profileInfo"
    }, m("h4", {
      className: "GorbeaUserDetails-username",
      style: "font-weight: 800; font-size: 1.3em; margin: 0;"
    }, user ? username(user) : 'Usuario'), m("span", {
      className: "GorbeaUserDetails-totalScore",
      style: "color: #EE2523; font-weight: bold; font-size: 1.1em; display: block; margin-top: 4px;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.total_score_label', {
      count: this.entry.score()
    })), m("span", {
      style: "color: #666; font-size: 0.9em; display: block; margin-top: 4px;"
    }, "\uD83D\uDC65 ", this.vote.attributes.sameVoteCount === 1 ? app.translator.trans('nagusi-match-ratings.forum.mundial.unique_vote') : app.translator.trans('nagusi-match-ratings.forum.mundial.shared_vote_count', {
      count: this.vote.attributes.sameVoteCount
    })))), m("div", {
      style: "display: flex; flex-direction: column; gap: 15px;"
    }, details.map(item => {
      return m("div", {
        style: "display: flex; justify-content: space-between; align-items: center; padding: 15px; background: #fafafa; border-radius: 12px; border: 1px solid #eee;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 12px;"
      }, m("span", {
        style: "background: ".concat(item.pot === 1 ? '#EE2523' : item.pot === 2 ? '#EF6C00' : item.pot === 3 ? '#4CAF50' : '#9C27B0', "; color: #fff; font-size: 0.8em; font-weight: bold; padding: 3px 8px; border-radius: 6px; white-space: nowrap; display: inline-block;")
      }, app.translator.trans('nagusi-match-ratings.forum.mundial.pot_label', {
        pot: item.pot
      })), m("div", {
        style: "display: flex; flex-direction: column;"
      }, m("span", {
        style: "font-weight: bold; font-size: 1.1em; color: #333;"
      }, item.team ? item.team.name() : app.translator.trans('nagusi-match-ratings.forum.mundial.default_pot_selection', {
        pot: item.pot
      })), item.team && m("span", {
        style: "font-size: 0.8em; color: #888; margin-top: 2px;"
      }, item.count === 1 ? app.translator.trans('nagusi-match-ratings.forum.mundial.team_chosen_count_singular', {
        count: item.count
      }) : app.translator.trans('nagusi-match-ratings.forum.mundial.team_chosen_count_plural', {
        count: item.count
      })))), m("span", {
        style: "font-weight: 800; color: #EE2523; font-size: 1.15em;"
      }, item.team ? item.team.attribute('points') : 0, " pts"));
    })));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/mundial/MundialUserDetailsModal', MundialUserDetailsModal);